import { get, post, put } from '../Services/http';
import { UPDATE_CHASSIDATA, UPDATE_SPAREPARTDATA, UPDATE_CHASSILOADING, CLEAR_CHASSIDATA, ERROR_CHASSIDATA }  from '../constants';
import constants from '../constants';
export const loadchassisearch = (searchstring) =>(dispatch)=> {
    searchstring=searchstring.replace(/\s+/g, '');
    dispatch(updatechassiloading(true));
    dispatch(errorchassisearch(false));
    return get('/api/chassi/chassisearch?searchString=' + searchstring + '&channelId=' + constants.channelId)
        .then((response) => response.json())
        .then((result) => {
            dispatch(receivechassisearch(result));
            dispatch(updatechassiloading(false));   
        })
        .catch((ex) => {
            dispatch(updatechassiloading(false));
            dispatch(errorchassisearch(true));
        });
};

export const loadSpareParts = (trailerId) => (dispatch) => {
    dispatch(updatechassiloading(true));
    dispatch(errorchassisearch(false));
    return get('/api/chassi/chassisearch?searchString=' + trailerId + '&channelId=' + constants.channelId + '&isSpareParts=' + true)
        .then((response) => response.json())
        .then((result) => {
            dispatch(receivesparepartsearch(result));
            dispatch(updatechassiloading(false));   
        })
        .catch((ex) => {
            dispatch(updatechassiloading(false));
            dispatch(errorchassisearch(true));
        });
}

export const clear = () => (dispatch) => {
    dispatch(updatechassiloading(false));
    dispatch(clearchassisearch());
}
export const clearchassisearch = () => (
    {
        type: CLEAR_CHASSIDATA
    }
)
export const errorchassisearch = (status) => (
    {
        type: ERROR_CHASSIDATA,
        payload: status,
    }
)
export const receivechassisearch = (chassi) => ({
    type: UPDATE_CHASSIDATA,
    payload: chassi,
});

export const receivesparepartsearch = (spareparts) => ({
    type: UPDATE_SPAREPARTDATA,
    payload: spareparts,
});

export const updatechassiloading = (status) => ({
    type: UPDATE_CHASSILOADING,
    payload: status,
});